<template>
    <div class="viewVIDEO">
        <div class="modal-conteudo m-2">
            <div v-if="dados">
                <h3 class="bold">{{dados.nmTitulo}}</h3>
                <p class="bold" v-html="dados.dsDescricao"></p>
                <template v-if="dados.tpExibicao == 'Local'">
                    <video class="w-100" controls :src="dados.urlVideo"></video>
                </template>
                <template v-else>
                    <iframe class="video-player" width="100%" height="500px" :src="getUrlVideo()" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                </template>
            </div>
        </div>

        <div class="modal-footer pb-0 mt-4 d-flex justify-content-end">
            <input style="display: none;" type="text" id="copyLink" :value="linkBase+'NoticiaVideo/?p_idVideo='+dados.idVideo" />
            <button class="btn btn-default txt-size-14" type="button" @click="copiarLink">
                <i class="fas fa-link"></i> Copiar link
            </button>

            <!--<AdicionarBiblioteca v-if="exibeBiblioteca" :id="dados.idVideo.toString()" :tipo="tpConteudo" :cdConteudo="cdConteudo"></AdicionarBiblioteca>-->
        </div>
    </div>
</template>

<script>
    import { urlPortal, avisoSucesso } from '@/config/global'

    export default {
        name: 'viewVIDEO',
        data: function () {
            return {
                linkBase: urlPortal || '',
            }
        },
        props: {
            dados: Object,
        },
        methods: {
            copiarLink() {
                var copyText = document.getElementById("copyLink");
                copyText.select();
                copyText.setSelectionRange(0, 99999);
                navigator.clipboard.writeText(copyText.value);

                avisoSucesso("Link copiado");
            },


            getUrlVideo() {
                if (this.dados.tpExibicao == 'Local') {
                    return this.dados.urlVideo
                }
                var url = '';
                var video = this.dados.urlVideo;
                    if (video.includes('vimeo.com')) {
                        let src = video.replace("https://vimeo.com/", "");
                        url = 'https://player.vimeo.com/video/' + src
                    } else if (video.includes('youtube')) {
                        let src = video.replace("https://www.youtube.com/watch?v=", "");
                        if (src.indexOf("&") > 0) {
                            src = src.substring(0, src.indexOf("&"));
                        }
                        url = 'https://www.youtube.com/embed/' + src
                    } else if (video.includes('youtu.be')) {
                        let src = video.replace("https://youtu.be/", "");
                        if (src.indexOf("?") > 0) {
                            src = src.substring(0, src.indexOf("?"));
                        }
                        url = 'https://www.youtube.com/embed/' + src
                    } else {
                        url = video;
                    }

                return url;
            },

        },
        watch: {
            dados: {
                handler() {
                },
                deep: true
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .video-responsivo{
        max-height: 500px;
    }
   
</style>

